// extracted by mini-css-extract-plugin
export var dividerLine = "_8e-3";
export var itemImage = "_8e-9";
export var lightDivider = "_8e-4";
export var modalContent = "_8e-5";
export var modalContentCompact = "_8e-6";
export var productCard = "_8e-a";
export var productImage = "_8e-b";
export var productImageCompact = "_8e-7";
export var productImagePlaceholder = "_8e-c";
export var productImagePlaceholderCompact = "_8e-8";
export var progressBarBackground = "_8e-1";
export var progressBarContainer = "_8e-0";
export var progressBarFill = "_8e-2";